import React, { Component } from "react";
import VoucherForm from "../VoucherForm/VoucherForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class VoucherPage extends Component{
    render(){
        return(
            <div>                    
                <VoucherForm/>
            </div>
        )   
    }
}

export default VoucherPage;